import { inject, Injectable } from '@angular/core'
import { UserState } from '../data-access/state/user.state'
import { Observable } from 'rxjs'
import { CodeTypeEvenement, EvenementDto } from '../data-access/http/dto/evenement-dto'
import { EvenementHttp } from '../data-access/http/evenement.http'
import { InsertionChantierDto } from '../../home/data-access/http/dto/insertion-chantier.dto'

@Injectable({ providedIn: 'root' })
export class EvenementDomainService {
  private userState = inject(UserState)
  private evenementService = inject(EvenementHttp)

  // Actions

  createSelectionChantierEvenement(codeChantier: string): Observable<EvenementDto> {
    const connectedUser = this.userState.store.selectSnapshot(UserState.getConnectedUser)
    const event = new EventBuilder()
      .utilisateurId(connectedUser.id)
      .codeTypeEvenement('SELECTION_CHANTIER')
      .codeChantier(codeChantier)
      .commentaire(`L'utilisateur ${connectedUser.idUtilisateurSi} a accédé au chantier ${codeChantier}`)

    return this.evenementService.createEvenement(event.build())
  }

  createModificationEngagementEvenement(codeChantier: string, avant: string, apres: string): Observable<EvenementDto> {
    const connectedUser = this.userState.store.selectSnapshot(UserState.getConnectedUser)
    const event = new EventBuilder()
      .utilisateurId(connectedUser.id)
      .codeTypeEvenement('MODIFICATION_ENGAGEMENT_HIN')
      .codeChantier(codeChantier)
      .commentaire(
        `L'utilisateur ${connectedUser.idUtilisateurSi} a modifié l’engagement : ${avant} -> ${apres} sur le chantier ${codeChantier}`
      )

    return this.evenementService.createEvenement(event.build())
  }

  createExportSheetEvenement(codeChantier: string): Observable<EvenementDto> {
    const connectedUser = this.userState.store.selectSnapshot(UserState.getConnectedUser)
    const event = new EventBuilder()
      .utilisateurId(connectedUser.id)
      .codeTypeEvenement('EXPORT_SHEET_HIN')
      .codeChantier(codeChantier)
      .commentaire(
        `L'utilisateur ${connectedUser.idUtilisateurSi} a demandé l’export du fichier sheets sur le chantier ${codeChantier}`
      )

    return this.evenementService.createEvenement(event.build())
  }

  createAjoutEntrepriseEvenement(codeChantier: string, entreprise: InsertionChantierDto): Observable<EvenementDto> {
    const connectedUser = this.userState.store.selectSnapshot(UserState.getConnectedUser)
    const typeSaisie = entreprise.key.startsWith('MANUEL_') ? ' (saisie manuelle)' : ''

    const event = new EventBuilder()
      .utilisateurId(connectedUser.id)
      .codeTypeEvenement('AJOUT_ENTREPRISE_HIN')
      .codeChantier(codeChantier)
      .commentaire(
        `L'utilisateur ${connectedUser.idUtilisateurSi} a ajouté l'entreprise ${entreprise.nom}${typeSaisie} sur le chantier ${codeChantier}`
      )

    return this.evenementService.createEvenement(event.build())
  }

  createSuppressionEntrepriseEvenement(
    codeChantier: string,
    entreprise: InsertionChantierDto
  ): Observable<EvenementDto> {
    const connectedUser = this.userState.store.selectSnapshot(UserState.getConnectedUser)

    const event = new EventBuilder()
      .utilisateurId(connectedUser.id)
      .codeTypeEvenement('SUPPRESSION_ENTREPRISE_HIN')
      .codeChantier(codeChantier)
      .commentaire(
        `L'utilisateur ${connectedUser.idUtilisateurSi} a supprimé l'entreprise ${entreprise.nom} sur le chantier ${codeChantier}`
      )

    return this.evenementService.createEvenement(event.build())
  }
}

class EventBuilder {
  private _codeTypeEvenement: CodeTypeEvenement
  private _date: Date
  private _utilisateurId: number
  private _commentaire: string
  private _codeChantier: string

  constructor() {
    this._date = new Date()
  }

  codeTypeEvenement(codeTypeEvenement: CodeTypeEvenement): EventBuilder {
    this._codeTypeEvenement = codeTypeEvenement
    return this
  }

  utilisateurId(utilisateurId: number): EventBuilder {
    this._utilisateurId = utilisateurId
    return this
  }

  commentaire(commentaire: string): EventBuilder {
    const now = new Date()
    this._commentaire = commentaire + `, le ${now.toLocaleDateString()} à ${now.toLocaleTimeString()}`
    return this
  }

  codeChantier(codeChantier: string): EventBuilder {
    this._codeChantier = codeChantier
    return this
  }

  build(): EvenementDto {
    return {
      date: this._date,
      utilisateurId: this._utilisateurId,
      codeChantier: this._codeChantier,
      commentaire: this._commentaire,
      codeTypeEvenement: this._codeTypeEvenement,
    }
  }
}
